module.exports = __webpack_public_path__ + "static/media/schoolImage.74e3f05b.jpeg";